// extracted by mini-css-extract-plugin
export default {"page":"w0-z","cartModal":"x0-z","checkout":"y0-z","placeholder":"z0-z","account":"A0-z"};